import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MessageService} from '../../../services/message.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'ngx-widget-setup-electricity-chart',
    templateUrl: './widget.setup.electricitychart.component.html',
    styleUrls: ['./widget.setup.electricitychart.component.scss'],
})

export class WidgetSetupElectricitychartComponent implements OnInit {

    form: FormGroup;
    data: any;
    addWidget: boolean;

    constructor(private activeModal: NgbActiveModal,
                private messageService: MessageService,
                private formBuilder: FormBuilder) {

        const self = this;

        this.data = {
            name: 'Electricity chart',
        };



    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            widgetName: [null, Validators.required],
        });




        if (this.data['id'] !== undefined) {
            this.addWidget = false;
        }else {
            this.addWidget = true;
        }
    }

    onSubmit() {

        this.messageService.saveWidget('electricity_chart', this.data);
        this.messageService.syncAllWidgets();
        this.activeModal.close();

    }

    closeModal() {
        this.activeModal.close();
    }


    private pad(i: number): string {
        return i < 10 ? `0${i}` : `${i}`;
    }

}



// WEBPACK FOOTER //
// /app/src/app/@core/component/add-widget/modal/widget.setup.electricitychart.component.ts